/**
 * @author Igor Bloom
 */
class ImagePacker{
  private algorithm = ''
  private readonly thumb_size:number = 300
	
  private algorithmID():string {
    if  (this.algorithm === ''){
      const aa = [0xff, 0xff, 0xdd, 0xdd, 0xff, 0xff]
      for (const i in aa)
        this.algorithm += String.fromCharCode(aa[i])
    }
    return this.algorithm 
  }

  async resizeImage(file: File): Promise<File> {
    return new Promise((resolve) => {
      const img = new Image()
      const reader = new FileReader()

      reader.onload = (e) => {
        img.src = e.target?.result as string
      }

      reader.readAsDataURL(file)

      img.onload = () => {
        const width = img.width
        const height = img.height

        if (width > this.thumb_size || height > this.thumb_size) {
          const canvas = document.createElement('canvas')
          const ctx = canvas.getContext('2d')!

          canvas.width = this.thumb_size
          canvas.height = this.thumb_size

          ctx.drawImage(img, 0, 0, this.thumb_size, this.thumb_size)
          canvas.toBlob((blob) => {
            if (blob) {
              const resizedFile = new File([blob], 'resized_' + file.name)
              resolve(resizedFile)
            }
          }, file.type)
        }
        else {
          resolve(file) // No need to resize
        }
      }
    })
  }

  get2ImagesForSend (theImage:HTMLImageElement, secKey:string):string[]|null{
    const thumb:HTMLCanvasElement = document.createElement('canvas')
    const context:CanvasRenderingContext2D|null = thumb.getContext('2d')
    if(!context) 	return null

    thumb.width = theImage.width
    thumb.height = theImage.height
    context.drawImage(theImage, 0, 0)

    let big:string = thumb.toDataURL('image/jpeg')
    let nn:number = big.indexOf(',') + 1
    big = big.substr(nn)
    context.clearRect(0, 0, thumb.width, thumb.height)
		
    thumb.width = thumb.height = this.thumb_size
    let ww:number = theImage.width
    let hh:number = theImage.height
		
    if (hh>ww) {
      hh = ww
    }
    else {
      ww = hh
    }
    context.drawImage(theImage, 0, 0, ww, hh, 0, 0, this.thumb_size, this.thumb_size)
    let small:string = thumb.toDataURL('image/jpeg')
    nn = small.indexOf(',') + 1
    small = small.substr(nn)
		
    big = atob(big)
    small = atob(small)

    //encrypted
    big = this.encrypt(big, secKey)
    small = this.encrypt(small, secKey)
		
    //convert to base 64 for sending ??? TODO
    big = btoa(big)
    small = btoa(small)
	
    return [big, small]
  }

  decrypt(buf:Uint8Array, key:string):Uint8Array|string|null {
    if (buf[0] !== 1) {
      // Data is not encrypted, return the original Uint8Array
      return new Uint8Array(buf)
    }
			
    let m = 0
    const lk = key.length
    let lb = buf.byteLength
    let ss = ''
    let nn
		
    for (let i=lb-6;i<lb;i++) {
      nn = buf[i]
      nn = nn < 0?(256 + nn):nn
      ss += String.fromCharCode(nn)
    }
    if (ss === this.algorithmID()){
      lb -= 6
    }
    ss = ''
    for (let i=1;i<lb;i++) {
      nn = buf[i] - key.charCodeAt(m)
      nn = nn<0?(256 + nn):nn
      ss += String.fromCharCode(nn)
      m = ++m < lk? m:0
    }
    return ss
  }

  encrypt(data:string, key:string):string{
    let m = 0
    let nn
    const lk = key.length
    const ld = data.length
    let ss:string = String.fromCharCode(1)
    for (let i=0;i<ld;i++) {
      nn = data.charCodeAt(i) + key.charCodeAt(m)
      nn = nn>255?(nn - 256):nn
      ss += String.fromCharCode(nn)
      m = ++m < lk? m:0
    }
    ss += this.algorithmID()
    return ss
  }
}
export { ImagePacker }